module.exports = __webpack_public_path__ + "img/bg_课程建设.8e51f5bf.png";